import clsx from 'clsx';
import GuestSidebar from './GuestSidebar';
import type { GuestLayoutProps } from '../../types/layout';

function GuestLayout({
  children,
  title,
  showAuthButtons = true,
  className,
}: GuestLayoutProps) {
  return (
    <div className={clsx('app-container flex min-h-screen', className)}>
      {/* Set page title */}
      {/* eslint-disable lingui/no-unlocalized-strings */}
      {title && <title>{title} - Instapaper</title>}
      {/* eslint-enable lingui/no-unlocalized-strings */}

      {/* Sidebar — desktop only on guest profile pages; mobile uses a header
          Sign In link instead of the drawer. md:contents keeps the parent
          flex layout intact when the rail is visible. */}
      {showAuthButtons && (
        <div className="hidden md:contents" data-testid="guest-side-nav-desktop">
          <div className="side-nav-container md:translate-x-0">
            <GuestSidebar />
          </div>
        </div>
      )}

      {/* Main content */}
      <main id="main-content" className="flex-fluid min-h-screen bg-white outline-none">
        {children}
      </main>
    </div>
  );
}

export default GuestLayout;
